import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";

import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";

const TextAreaGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };

  const handleFontWeightChange = (event) => {
    dispatch({
      type: ACTIONS.TEXTAREA_FONT_WEIGHT_INPUT,
      payload: event.target.value,
    });
  };

  const handleTextAreaWidthUnitsChange = (event) => {
    dispatch({
      type: ACTIONS.TEXTAREA_WIDTH_UNITS,
      payload: event.target.value,
    });
  };

  const handleFontFamilyChange = (event) => {
    dispatch({
      type: ACTIONS.TEXTAREA_FONT_FAMILY_CHANGE,
      payload: event.target.value,
    });
  };

  return (
    <>
      <div className="input-group-wrapper">
        {/* ################################################################################ */}

        <InputSection
          id="textAreaTopSpacing"
          title="Spacing above"
          value={state.textAreaTopSpacing}
          actionTypeIncrement={ACTIONS.TEXTAREA_TOP_SPACING_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_TOP_SPACING_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_TOP_SPACING_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="textAreaPaddingInline"
          title="Inline padding"
          value={state.textAreaPaddingInline}
          actionTypeIncrement={ACTIONS.TEXTAREA_INLINE_PADDING_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_INLINE_PADDING_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_INLINE_PADDING_INPUT}
          dispatch={dispatch}
        />
      </div>
      <h2 className="section-subheader">Field styles</h2>
      <div className="input-group-wrapper">

        <InputSection
          id="textAreaHeight"
          title="textArea field height"
          value={state.textAreaHeight}
          actionTypeIncrement={ACTIONS.TEXTAREA_HEIGHT_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_HEIGHT_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_HEIGHT_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="textAreaWidth"
          title="textArea field width"
          value={state.textAreaWidth}
          actionTypeIncrement={ACTIONS.TEXTAREA_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_WIDTH_INPUT}
          dispatch={dispatch}
        />

        <div>
          <p>Width by units</p>
          <CustomSelect
            labelId="width-by-units"
            id="width-by-units"
            selectValue={state.textAreaWidthUnits}
            selectLabel="Width by units"
            selectOnChange={handleTextAreaWidthUnitsChange}
            menuItems={[
              { value: "%", label: "%" },
              { value: "px", label: "px" },
            ]}
          />
        </div>

      </div>
      <h2 className="section-subheader">Font styles</h2>
      <div className="input-group-wrapper">

        <div className="form-builder-section-div">
          <p>Font Family</p>
          <FontFamilySelect
          selectedFontFamily={state.textAreaFontFamily}
          onFontFamilyChange={handleFontFamilyChange}
        />
        </div>

        <InputSection
          id="textAreaFontSize"
          title="Font size"
          value={state.textAreaFontSize}
          actionTypeIncrement={ACTIONS.TEXTAREA_FONT_SIZE_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_FONT_SIZE_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_FONT_SIZE_INPUT}
          dispatch={dispatch}
        />
        <div>
          <p>Font Weight</p>
          <CustomSelect
            labelId="font-weight-textArea"
            id="font-weight-textArea"
            selectValue={state.textAreaFontWeight}
            selectLabel="Font Weight"
            selectOnChange={handleFontWeightChange}
            menuItems={[
              { value: 100, label: "100" },
              { value: 200, label: "200" },
              { value: 300, label: "300" },
              { value: 400, label: "400" },
              { value: 500, label: "500" },
              { value: 600, label: "600" },
              { value: 700, label: "700" },
              { value: 800, label: "800" },
              { value: 900, label: "900" },
            ]}
          />
        </div>
      </div>
      <h2 className="section-subheader">Border styles </h2>
      <div className="form-builder-section-div-checkmark">
        <input
          type="checkbox"
          checked={state.textareaBorderStyleCheckbox === "none"}
          onChange={() => dispatch({ type: ACTIONS.TEXTAREA_TOGGLE_BORDER_STYLE })}
        />
        <p>Border bottom only?</p>
      </div>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.textAreaBorderColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_BORDER_COLOR_INPUT)}
          />
        </div>
        <InputSection
          id="textAreaBorderWidth"
          title="Border width"
          value={state.textAreaBorderWidth}
          actionTypeIncrement={ACTIONS.TEXTAREA_BORDER_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_BORDER_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_BORDER_WIDTH_INPUT}
          dispatch={dispatch}
        />

        {/* ################################################################################ */}

        <InputSection
          id="textAreaBorderRadius"
          title="Border radius"
          value={state.textAreaBorderRadius}
          actionTypeIncrement={ACTIONS.TEXTAREA_BORDER_RADIUS_INCREMENT}
          actionTypeDecrement={ACTIONS.TEXTAREA_BORDER_RADIUS_DECREMENT}
          actionTypeInput={ACTIONS.TEXTAREA_BORDER_RADIUS_INPUT}
          dispatch={dispatch}
        />
      </div>
      {/* ################################################################################ */}
      <h2 className="section-subheader">Color styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.textAreaColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_COLOR_INPUT)}
          />
        </div>

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.textAreaBackgroundColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_BACKGROUND_INPUT)}
          />
        </div>
      </div>
      {/* ################################################################################ */}

      {/* ################################################################################ */}

      <h2 className="section-subheader">Hover styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.textAreaHoverColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_HOVER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.textAreaHoverBorderColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_HOVER_BORDER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.textAreaHoverBackgroundColor}
            onChange={handleColorChange(ACTIONS.TEXTAREA_HOVER_BACKGROUND_INPUT)}
          />
        </div>
      </div>
    </>
  );
};

export default TextAreaGroup;
